import { Component, inject, OnDestroy, OnInit, output, signal } from '@angular/core';
import { Observable, of, Subject, takeUntil } from 'rxjs';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { ButtonComponent } from '../../../common/components/button/button.component';
import { MatIcon } from '@angular/material/icon';
import { AsyncPipe, NgClass } from '@angular/common';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { CounterBadgeComponent } from '../../../common/components/counter-badge/counter-badge/counter-badge.component';
import { OrgAdminEndpointsService } from '../../../services/org-service/org-admin-endpoints.service';
import { DomainDto } from '../org-model/domain-dto.interface';
import { DropdownComponent } from '../../../common/components/dropdown/dropdown.component';
import { MatListItem, MatListItemIcon, MatNavList } from '@angular/material/list';
import { environment } from '../../../../environments/environment';
import { OrgLeftSidebarTestIds } from './org-left-sidebar.test-ids';
import { MatTooltip } from '@angular/material/tooltip';

@Component({
  selector: 'app-org-left-sidebar',
  imports: [
    ButtonComponent,
    MatIcon,
    RouterLink,
    CounterBadgeComponent,
    AsyncPipe,
    DropdownComponent,
    RouterLinkActive,
    MatListItem,
    MatNavList,
    MatTooltip,
    MatListItemIcon,
    NgClass
  ],
  templateUrl: './org-left-sidebar.component.html',
  styleUrl: './org-left-sidebar.component.scss'
})
/**
 * Begründung: Es handelt sich nur um die Sidebar für den Org-Admin, keine direkte AFO erüllt.
 */
export class OrgLeftSidebarComponent implements OnDestroy, OnInit {
  isOpen = true;
  destroyed = new Subject<boolean>();
  isSidebarHidden = signal<boolean>(localStorage.getItem('sidenavState') !== 'opened');
  domain$: Observable<DomainDto[]> = of([]);
  isSidebarHiddenOutput = output<boolean>();
  protected readonly testIds = OrgLeftSidebarTestIds;
  protected readonly oidcSecurityService = inject(OidcSecurityService);
  protected readonly orgAdminEndpointsService = inject(OrgAdminEndpointsService);
  protected readonly environment = environment;

  public logout(): void {
    this.oidcSecurityService.logoff().pipe(takeUntil(this.destroyed)).subscribe();
  }

  public toggleSidebar(): void {
    this.isSidebarHidden.set(!this.isSidebarHidden());
    localStorage.setItem('sidenavState', this.isSidebarHidden() ? 'closed' : 'opened');
    this.isSidebarHiddenOutput.emit(this.isSidebarHidden());
  }

  ngOnDestroy(): void {
    this.destroyed.next(true);
    this.destroyed.complete();
  }

  ngOnInit(): void {
    this.domain$ = this.orgAdminEndpointsService.domainList();
  }
}
